<template>
  <v-container>
    Anking
    <v-combobox :items="decks" v-model="selectedDeck">

    </v-combobox>

    <v-card v-for="(x, i) in content[selectedDeck]" :key="i">
      <p>{{x.anki_id}}</p>
      <p v-html="parseTest(x.content.Text, false)"></p>
      <p v-html="parseTest(x.content.Text, true)"></p>
      <!-- <img v-for="(i, y) in getSRC(x.content.Extra)" :key="y" :src="'https://omentum.s3.us-east-1.amazonaws.com/img/' + i"/> -->



    </v-card>
  </v-container>
</template>
<script>
import DecksData from '@/anki/pharm-deck-data.json'

export default {
  name: 'Anking',
  data() {
    return {
      decks: Object.keys(DecksData).sort(),
      selectedDeck: null,
      content: DecksData

    }
  },
  computed: {

  },
  methods: {
    getSRC(str){
      var m,
          urls = [],
          rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;

      while ( m = rex.exec( str ) ) {
          urls.push( m[1] );
      }
      return urls
    },
    parseTest(inv, showAnswer) {
      let result = []
      let entries = inv.match(/{{([^}]+)}}/g)
      inv.match(/{{([^}]+)}}/g).forEach(item => result.push(item.replace("}}","").split("::")))

      var str = (' ' + inv).slice(1)

      entries.forEach((x,i) => {
        if (!showAnswer) {
          if (result[i].length > 2) {
            str = str.replace(x, "<span class='grey--text closure'>" + result[i][2] + "</span>" )
          }
          else {
            str = str.replace(x, "<span class='white--text closure'>" + result[i][1] + "</span>" )
          }
        }
        else {
          str = str.replace(x, "<span class='blue--text'>" + result[i][1] + "</span>")
        }


      })


      return str
    }
  }
}
</script>
<style>

</style>
